"use client";

import RecommendedForYou from "@/app/ec/product/recommendations/wrappers/recommendedForYou";
import style from "./homePageProductRecommendations.module.scss";

export default function HomePageProductRecommendations() {
  return (
    <section id="recommended-for-you" className={style.containsRecommendations}>
      <RecommendedForYou
        className={style.recommendationsInner}
        compactMobilePagination
        fullWidthGrid={true}
        fallbackModel="trending-items"
        modelParams={{
          fallbackParameters: {
            query: "",
            filters: `availability:Y`,
          },
          queryParameters: {
            filters: `availability:Y`,
          },
        }}
        title="Recommended for You"
        orderBy="priority"
        displayGrid={true}
        slideBreakpoints={{
          0: 1,
          250: 2,
          500: 3,
          750: 4,
          1000: 5,
          1250: 6,
        }}
      />
    </section>
  );
}
